<div class="form-container new-ticket">
    <div class="row heading-row">
        <div class="col-4">
            <h3 class="pl-5">New {{ticketLabel}} Ticket</h3>
        </div>
        <div class="col text-right">
            <button mat-raised-button color="primary" class="submit-btn" (click)="submitNewTicket()" [disabled]="!disableSubmit()">Create Ticket</button>
            <button mat-raised-button class="cancel-btn mr-5" (click)="router.navigate(['/tickets'])">Cancel</button>
        </div>
    </div>

    <div class="row content-area">
        <mat-card class="col">
            <mat-card-header>
                <mat-card-title>Basic Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col-4" [ngClass]="{'col-12': ticketType === 'C'}">
                        <mat-label>Ticket Title</mat-label>
                        <input required matInput type="text" class="ticket-title" [(ngModel)]="title"/>
                    </mat-form-field>
                    <mat-form-field class="col-4" [ngClass]="{'col-6': ticketType === 'C'}">
                        <mat-label>Requested by</mat-label>
                        <mat-select [(value)]="requestedBy"
                                    class="requested-by">
                            <mat-option [value]="activeUser">{{ activeUser.username | toName: cuContacts }}</mat-option>
                            <mat-option *ngFor="let user of cuContacts" [value]="user">{{ user.username | toName: cuContacts }}</mat-option>
                        </mat-select>
                    </mat-form-field>
<!--                    <mat-form-field class="col" [ngClass]="{'col-6': ticketType === 'C'}">-->
<!--                        <mat-label>Ticket Type</mat-label>-->
<!--                        <mat-select [(value)]="ticketType" (valueChange)="changeLabel()">-->
<!--                            <mat-option *ngFor="let type of typeDropdown" [value]="type.value">{{type.label}}</mat-option>-->
<!--                        </mat-select>-->
<!--                    </mat-form-field>-->
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="ticketType === 'C'" class="col-6 community-points">
            <mat-card-header>
                <mat-card-title>Community Points</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <div class="col">
                        <div class="text-center">
                            <h4 style="padding-top: 41px">Current Points: {{totalCommunityPoints}}</h4>
                        </div>
                    </div>
                    <div class="col text-center">
                        <p class="text-left text-muted" style="padding-left: 15px">Available Points: {{availablePoints}}</p>
                        <div class="row">
                            <h4 class="point-display">Your Points:</h4>
                            <button mat-icon-button class="pointBtn dec-btn" (click)="decreasePoints()"><i class="fa fa-minus"></i></button>
                            <input matInput type="text" readonly [(ngModel)]="addedPoints" class="point-input">
                            <button mat-icon-button color="primary" class="pointBtn inc-btn" (click)="increasePoints()"><i class="fa fa-plus"></i></button>
                        </div>
                    </div>
                </div>
                <hr>
                <mat-card-footer>
                    <p class="text-center text-muted"><i>*If approved, other credit unions can apply points towards your enhancement ticket*</i></p>
                </mat-card-footer>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row community-reason content-area" *ngIf="ticketType === 'C'">
        <mat-card class="col">
            <mat-card-header>
                <mat-card-title>Reason for Community Ticket</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col" floatLabel="always">
                        <mat-label></mat-label>
                        <textarea rows="10" cols="100" style="resize: none" matInput type="text" [(ngModel)]="note"
                                  placeholder="{{placeholderInfo.communityPlaceholder}}"></textarea>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row community-reason content-area" *ngIf="ticketType === 'E'">
        <mat-card class="col">
            <mat-card-header>
                <mat-card-title>Reason for Enhancement</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col" floatLabel="always">
                        <mat-label></mat-label>
                        <textarea rows="10" cols="100" style="resize: none" matInput type="text" [(ngModel)]="note"
                                  placeholder="{{placeholderInfo.enhancementPlaceholder}}"></textarea>
                    </mat-form-field>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row content-area" *ngIf="ticketType === ''">
        <mat-card class="col">
            <mat-card-header>
                <mat-card-title>Notes</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <mat-form-field class="col" floatLabel="always">
                        <mat-label></mat-label>
                        <textarea class="ticket-notes"
                                  rows="10"
                                  cols="100" style="resize: none"
                                  matInput type="text"
                                  [(ngModel)]="note"
                                  placeholder="{{placeholderInfo.notePlaceholder}}"
                                  required></textarea>
                    </mat-form-field>
                </div>
                <div class="text-right">
                    <button mat-raised-button color="primary" class="submit-note-btn text-right" (click)="submitNewTicket()" [disabled]="!note">Save</button>
                    <button mat-raised-button class="cancel-btn text-right" (click)="router.navigate(['/tickets'])">Cancel</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="row content-area">
        <mat-card class="col-12">
            <mat-card-header>
                <mat-card-title>Attachments</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="row" *ngIf="ticketsService.selectedTicketAttachments | async">
                    <div class="col text-center">
                        <button class="btn btn-primary attachment"
                                matTooltip="Download Attachment"
                                *ngFor="let attachment of ticketsService.selectedTicketAttachments | async"
                                (click)="ticketsService.downloadAttachment(attachment.fileName)">
                            File Name: {{attachment.fileName}}</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <input type="file" accept=".png, .jpg, .jpeg, .pdf, .txt"
                               (change)="ticketsService.fileSelected($event)"
                               multiple="multiple">
                        <p class="text-muted">Supported file types: .jpg, .pdf, .png, .txt</p>
                        <p class="text-muted"><i>Max file size: 5MB</i></p>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>


